var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import styled from "styled-components";
import { AfyInput } from "@affinitysystemsgroup/assurehub-ui";
export var SetDataFieldsRow = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--mantine-spacing-md);\n"], ["\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: var(--mantine-spacing-md);\n"])));
export var SetDataFieldsInput = styled(AfyInput)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  label {\n    font-weight: 700;\n  }\n"], ["\n  label {\n    font-weight: 700;\n  }\n"])));
var templateObject_1, templateObject_2;
